import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Global, css } from '@emotion/react';
import { Routes, Route, useLocation } from 'react-router-dom';
import theme from './theme';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Technology from './components/Technology';
import IndustryTransformation from './components/IndustryTransformation';
import Products from './components/Products';
import Approach from './components/Approach';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Career from './pages/Career';
import styled from '@emotion/styled';

// Import fonts
import '@fontsource/lobster';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

const globalStyles = css`
  html, body {
    scroll-behavior: smooth;
    overflow-x: hidden;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  body {
    background: ${theme.palette.background.default};
    color: ${theme.palette.text.primary};
    font-family: ${theme.typography.fontFamily};
    max-width: 100vw;
  }

  * {
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  #root {
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.palette.background.default};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.palette.primary.main};
    border-radius: 5px;
    
    &:hover {
      background: ${theme.palette.primary.light};
    }
  }
`;

const AppContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  background: #000B18;
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;

  & > * {
    overflow-x: hidden;
  }
`;

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      setTimeout(() => {
        const element = document.querySelector(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Technology />
      <IndustryTransformation />
      <Products />
      <Approach />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Global styles={globalStyles} />
      <AppContainer>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/career" element={<Career />} />
        </Routes>
      </AppContainer>
    </ThemeProvider>
  );
}

export default App; 